import PropTypes from 'prop-types';
export var MAP_SEARCH_PROPS = {
  hiddenProperties: PropTypes.number,
  isTruncatedResult: PropTypes.bool,
  markers: PropTypes.arrayOf(PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number,
    count: PropTypes.number,
    type: PropTypes.oneOf(['default', 'visited', 'shortlisted'])
  })),
  defaultCenter: PropTypes.shape({
    lat: PropTypes.number,
    lon: PropTypes.number
  }),
  baseClass: PropTypes.string,
  onChange: PropTypes.func,
  onMarkerClick: PropTypes.func,
  zoom: PropTypes.number,
  bootstrapURLKeys: PropTypes.shape({
    key: PropTypes.string.isRequired
  }).isRequired
};
export var BOUNDS_PROPS = {
  from: PropTypes.shape({
    lat: PropTypes.number,
    lon: PropTypes.number
  }),
  to: PropTypes.shape({
    lat: PropTypes.number,
    lon: PropTypes.number
  }),
  isTruncatedResult: PropTypes.bool
};
export default PropTypes.shape(MAP_SEARCH_PROPS);